import styled from "styled-components";

export const CollaboratorInitialSchedulingModalRadioContainer = styled.div<{width?: number}>`
  width: ${(props) => (props.width ? props.width + "%" : "100%")};
  text-align: left;
  gap: 5px;
`;

export const CollaboratorInitialSchedulingModalRadioHeader = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const SchedulingModalOverFlow = styled.div<{isMobile?: boolean}>`
overflow-y: ${(props) => (props.isMobile ? "scroll" : "hiden")};
height: 300px;
`
